import Grid from './Grid'
import HalfCell from './HalfCell'
import ThirdCell from './ThirdCell'
import FullCell from "./FullCell";

Grid.HalfCell = HalfCell
Grid.ThirdCell = ThirdCell
Grid.FullCell = FullCell

export default Grid



// WEBPACK FOOTER //
// ./src/components/Grid/index.js